import { gql } from '@apollo/client'

export const FILTER_SIDEBAR_QUERY = gql`
  query FILTER_SIDEBAR_QUERY($filter: FilterFilterInput, $order: OrderInput, $pagination: PaginationInput) {
    filters(filter: $filter, order: $order, pagination: $pagination) {
      data {
        id
        name
        slug
        companyId
        meta
      }
    }
  }
`
